import Env from '../config/envConfig'
import { addCsrfHeaders } from '../config/csrf'

export interface ChangePasswordRequest {
  oldPassword: string
  newPassword: string
}

export interface AdminChangePasswordRequest {
  newPassword: string
  reason?: string
}

class PasswordApi {
  private basePath = Env.basePath

  private getHeaders (): HeadersInit {
    const requestHeaders: HeadersInit = new Headers()
    requestHeaders.set('Accept', 'application/json')
    requestHeaders.set('Content-Type', 'application/json')
    addCsrfHeaders(requestHeaders)
    return requestHeaders
  }

  /**
   * Change own password
   */
  async changeOwnPassword (data: ChangePasswordRequest): Promise<Response> {
    const url = `${this.basePath}/api/password/change`
    return fetch(url, {
      method: 'PUT',
      credentials: 'include',
      headers: this.getHeaders(),
      body: JSON.stringify(data),
    })
  }

  /**
   * Admin: Change another user's password
   */
  async changeUserPasswordAsAdmin (userId: string, data: AdminChangePasswordRequest): Promise<Response> {
    const url = `${this.basePath}/api/password/admin/change/${userId}`
    return fetch(url, {
      method: 'PUT',
      credentials: 'include',
      headers: this.getHeaders(),
      body: JSON.stringify(data),
    })
  }
}

export const passwordApi = new PasswordApi()
